import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import {
  Checkbox,
  ControlLabel,
} from 'react-bootstrap';

const propTypes = exact({
  showTerminatedUsers: PropTypes.bool.isRequired,
  setShowTerminatedUsersAction: PropTypes.func.isRequired,
});


const TerminatedUsersCheckbox = (props) => {
  const {
    showTerminatedUsers, setShowTerminatedUsersAction,
  } = props;

  const handleToggleCheckbox = (e) => {
    const { target: { checked } } = e;
    setShowTerminatedUsersAction(checked);
  };

  return (
    <React.Fragment>
      <Checkbox
        checked={showTerminatedUsers}
        inline
        onChange={(e) => { return handleToggleCheckbox(e); }}
      >
        <ControlLabel className="control-label">Include Terminated Employees</ControlLabel>
      </Checkbox>
    </React.Fragment>
  );
};

TerminatedUsersCheckbox.propTypes = propTypes;


export default TerminatedUsersCheckbox;
